'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../../components/buttons/Button/index';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';

export class ToastMessageView extends Component {
  static propTypes = {
    className: T.string,
    title: T.string,
    message: T.string,
    action: T.shape({
      className: T.string,
      label: T.string,
      handler: T.func,
    }),
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.handleAction = this.handleAction.bind(this);
  }

  handleAction(e) {
    const props = this.props;
    if (isObject(props.action) && isFunction(props.action.handler)) {
      props.action.handler();
    }

    if (isFunction(props.closeToast)) {
      props.closeToast(e);
    }
  }

  /**
   * Reuses NotificationItem__actions CSS class so that any styling of buttons gets a consistent container.
   * @return {*}
   */
  render() {
    const props = this.props;
    return (
      <div
        className={classNames("ToastMessage", props.className)}
        onClick={props.onClick}
      >
        <div className="ToastMessage__left">
          <div
            className={classNames("ToastMessage__title", {
              ToastMessage__title_message: props.message,
            })}
          >
            {props.title}
          </div>
          {props.message ? (
            <div className="ToastMessage__message">
              {props.type === 'error' ? <i className="icon ion-alert-circled" /> : null}
              <span>
                {props.message}
              </span>
            </div>
          ) : null}
        </div>
        {props.action ? (
          <div className="NotificationItem__actions">
            <Button
              className={'BaseButton ' + props.action.className}
              label={props.action.label}
              onClick={this.handleAction}
            />
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/toast-messages/compnents/ToastMessage/ToastMessageView.js